export default "__VITE_ASSET__77f91095__"